import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M44 4H12V36H44V4ZM36 14H30V25C30 26.3261 29.4732 27.5979 28.5355 28.5355C27.5979 29.4732 26.3261 30 25 30C23.6739 30 22.4021 29.4732 21.4645 28.5355C20.5268 27.5979 20 26.3261 20 25C20 23.6739 20.5268 22.4021 21.4645 21.4645C22.4021 20.5268 23.6739 20 25 20C26.14 20 27.16 20.38 28 21.02V10H36V14ZM8 12H4V44H36V40H8V12Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}